
import NWSAlertsList from 'components/StormCenter/displays/NWSAlertsList';
import { useState } from 'react';
import { useGetCWActiveAlertsQuery } from 'services/alerts/alerts.api';
import { ErrorMessage } from './ErrorMessage';
import WidgetLoadingAnimation from './WidgetLoadingAnimation';
import WidgetTimeUpdate from './WidgetTimeUpdate';

export default function MyAdvisoriesWidget({ widgetRefresh, setWidgetRefresh, dimensions }) {
  const [error, setError] = useState({ state: false, message: '' });
  const { data: cwActiveAlerts, isFetching } = useGetCWActiveAlertsQuery();
  const localAlertsSortedByTime = cwActiveAlerts?.result?.sort((a, b) => {
    return new Date(b.sentTime) - new Date(a.sentTime);
  });

  const ROUTE = 'getCWActiveAlerts';

  if (error.state && !isFetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
        }}
      />
    );
  }

  // if (true)
  if (isFetching)
    return <WidgetLoadingAnimation widgetName={'MyAdvisories'} dimensions={dimensions} />;

  if (localAlertsSortedByTime && localAlertsSortedByTime.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} realtime />
        <div style={{ padding: 15 }}>No data found.</div>
      </div>
    );
  }

  if (dimensions[0] === 1 && dimensions[1] === 2)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={ROUTE} realtime />
        <div
          style={{
            height: 'calc(100% - 20px)',
            overflowX: 'hidden',
          }}
        >
          <NWSAlertsList localAlerts={localAlertsSortedByTime} />
        </div>
      </div>
    );
  if (dimensions[0] === 1 && dimensions[1] === 1)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={ROUTE} realtime />
        <div
          style={{
            height: 'calc(100% - 20px)',
            overflowX: 'hidden',
          }}
        >
          <NWSAlertsList localAlerts={localAlertsSortedByTime} />
        </div>
      </div>
    );

  if (dimensions[0] === 2 && dimensions[1] === 1)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={ROUTE} realtime />
        <div
          style={{
            height: 'calc(100% - 20px)',
            overflowX: 'hidden',
          }}
        >
          <NWSAlertsList localAlerts={localAlertsSortedByTime} />
        </div>
      </div>
    );
}
